import safe from 'safe-await'

const endpoint = (append = '') => `${process.env.VUE_APP_PROVIDER}${append}`

export const getBookingOptions = async () => {
  const [error, response] = await safe(window.axios.get(endpoint('/bookingoptions/index')))

  return error ? [error] : [error, response.data]
}

export const storeBookingOption = async (payload) => {
  const [error, response] = await safe(window.axios.post(endpoint('/bookingoptions/storebookingoption'), payload))

  return error ? [error] : [error, response.data]
}

export const updateBookingOption = async (bookingOptionId, payload) => {
  const [error, response] = await safe(window.axios.post(endpoint(`/bookingoptions/updatebookingoption/${bookingOptionId}`), payload))

  return error ? [error] : [error, response.data]
}

export const deleteBookingOption = async (bookingOptionId, migrateBookingOptionId = null) => {
  const [error, response] = await safe(window.axios.post(endpoint(`/bookingoptions/deletebookingoption/${bookingOptionId}`), { id: migrateBookingOptionId }))

  return error ? [error] : [error, response.data]
}

export const getCostCenters = async () => {
  const [error, response] = await safe(window.axios.get(endpoint('/bookingoptions/getcostcenters')))

  return error ? [error] : [error, response.data]
}

export const storeCostCenter = async (payload) => {
  const [error, response] = await safe(window.axios.post(endpoint('/bookingoptions/storecostcenter'), payload))

  return error ? [error] : [error, response.data]
}

export const updateCostCenter = async (costCenterId, payload) => {
  const [error, response] = await safe(window.axios.post(endpoint(`/bookingoptions/updatecostcenter/${costCenterId}`), payload))

  return error ? [error] : [error, response.data]
}

export const deleteCostCenter = async (costCenterId, migrationCostCenterId = null) => {
  const [error, response] = await safe(window.axios.post(endpoint(`/bookingoptions/deletecostcenter/${costCenterId}`), { item_cost_center_id: migrationCostCenterId }))

  return error ? [error] : [error, response.data]
}

export const getGroupedBookingOptions = async (group) => {
  const [error, response] = await safe(window.axios.post(endpoint(`/bookingoptions/grouped/${group}`)))

  return error ? [error] : [error, response.data]
}

export default {
  deleteBookingOption,
  deleteCostCenter,
  getBookingOptions,
  getCostCenters,
  getGroupedBookingOptions,
  storeBookingOption,
  storeCostCenter,
  updateBookingOption,
  updateCostCenter
}
